import React, { useState } from "react";
import "../css/user.css";
import arrow from '../img/arrow.png';
import '../css/popup.css';
import Modal from '../components/popupModalMines';

function OutputChoose({
  name,
  date,
  download,
  textAction,
  action,
  deleteFile,
  renameFile,
  // 🔹 nuove prop per selezione multipla
  selectable = false,
  selected = false,
  onToggle,
}) {
  const [isManageMineVisible, setIsManageMineVisible] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isRenameModalOpen, setIsRenameModalOpen] = useState(false);
  const [newName, setNewName] = useState("");

  const toggleManageMine = () => {
    setIsManageMineVisible(!isManageMineVisible);
  };

  const openDeleteModal = () => {
    setIsDeleteModalOpen(true);
  };

  const openRenameModal = () => {
    setIsRenameModalOpen(true);
  };

  const confirmDelete = () => {
    deleteFile && deleteFile();
    console.log("File deleted permanently");
    setIsDeleteModalOpen(false);
  };

  const confirmRename = () => {
    renameFile && renameFile(newName);
    console.log("File renamed to:", newName);
    setIsRenameModalOpen(false);
  };

  return (
    <>
      <div className="output">
        <p className="textlink OutputField">
          <b>Name:</b> {name}
        </p>
        {date && (
          <p className="textlink smallOutputField">
            <b>Date:</b> {date}
          </p>
        )}

        <div>
          {/* Modalità standard: bottone */}
          {!selectable && (
            <button
              type="submit"
              className="button buttonUser"
              onClick={action}
            >
              {textAction}
            </button>
          )}

          {/* Modalità selezione multipla: checkbox */}
          {selectable && (
            <label
              className="textlink"
              style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}
            >
              <input
                type="checkbox"
                className="multiselect"
                checked={selected}
                onChange={(e) => onToggle && onToggle(e.target.checked)}
                onClick={(e) => e.stopPropagation()}
              />
            </label>
          )}
        </div>
      </div>
    </>
  );
}

export default OutputChoose;
